
import { mixins } from 'vue-class-component';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CustomModal from '@/components/modal/CustomModal.vue';
import EventEditorInviteForm from '@/components/event-editors/EventEditorInviteForm.vue';
import ToastMixin from '@/mixins/ToastMixin';
import ToastVariant from '@/model/enums/toast/toast-variant';
import { EventResponse, resolveEventProjectId } from '@/model/Event';
import { ApiError } from '@/model/ApiError';
import { InviteInformation, InviteRequest, Project } from '@/model/Project';

@Component({
    components: {
        CustomModal,
        EventEditorInviteForm,
    },
    computed: {
        ...mapGetters({
            projects: 'customerProjectStorage/getProjects',
            inviteError: 'customerProjectStorage/getError',
        }),
    },
    methods: {
        ...mapActions({
            inviteByEmail: 'customerProjectStorage/invite',
            getAllProjects: 'customerProjectStorage/getAllProjects',
        }),
        ...mapMutations({
            setInviteError: 'customerProjectStorage/setError',
        }),
    },
})
export default class EventEditorInviteButton extends mixins(ToastMixin) {
    @Prop() eventId!: number;

    @Prop() event!: EventResponse | null;

    inviteByEmail!: (inviteRequest: InviteRequest) => Promise<void>;

    getAllProjects!: (onlyActives: boolean) => Promise<void>;

    setInviteError!: (error: ApiError | null) => void;

    projects!: Project[];

    inviteError!: ApiError | null;

    loading = false;

    inviteSection = true;

    inviteFailed = false;

    invitedEmail = '';

    inviteFormKey = 0;

    openInviteModal(): void {
        this.inviteSection = true;
        this.inviteFailed = false;
        this.invitedEmail = '';
        this.inviteFormKey += 1;
        this.setInviteError(null);
    }

    closeInviteModal(): void {
        this.inviteFailed = false;
        this.setInviteError(null);
    }

    async inviteEditor(request: InviteInformation): Promise<void> {
        this.loading = true;
        this.inviteFailed = false;
        this.invitedEmail = request.email;

        try {
            let projectId = resolveEventProjectId(this.event, this.projects);

            if (projectId === null) {
                await this.getAllProjects(false);
                projectId = resolveEventProjectId(this.event, this.projects);
            }

            if (projectId === null) {
                throw new Error('Event project could not be resolved');
            }

            await this.inviteByEmail({
                projectId,
                ...request,
            });
            this.inviteSection = false;
            this.invited();
            this.showToast(
                this.$t('invite.success').toString(),
                this.$t('success-title').toString(),
                ToastVariant.SUCCESS,
            );
        } catch {
            this.inviteFailed = true;
        } finally {
            this.loading = false;
        }
    }

    @Emit()
    invited(): void {
        // invited emit
    }
}
